import React from 'react';
import PropTypes from 'prop-types';
import ContactElement from '../ContactElement';

export default class Email extends React.PureComponent {
  getEmailLink() {
    const { email } = this.props;
    return `mailto:${email};`;
  }

  render() {
    const {
      email,
      as,
      header,
      iconPosition,
      showIcon,
      buttonColor,
      className,
      fluidButton,
      buttonSize,
    } = this.props;

    return (
      <ContactElement
        contact={email}
        link={this.getEmailLink()}
        iconType={showIcon || as === 'icon' ? 'mail' : 'none'}
        as={as}
        iconPosition={iconPosition}
        header={header}
        className={className}
        buttonColor={buttonColor}
        fluidButton={fluidButton}
        buttonSize={buttonSize}
      />
    );
  }
}

Email.propTypes = {
  email: PropTypes.string.isRequired,
  as: PropTypes.oneOf(['text', 'button', 'icon']),
  buttonColor: PropTypes.string,
  buttonSize: PropTypes.string,
  className: PropTypes.string,
  fluidButton: PropTypes.bool,
  header: PropTypes.string,
  iconPosition: PropTypes.string,
  showIcon: PropTypes.bool,
};

Email.defaultProps = {
  as: 'text',
  buttonColor: 'default',
  buttonSize: 'large',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showIcon: false,
};

Email.propOptions = {
  buttonColor: ['primary', 'secondary', 'default'],
  header: ['Email', 'Our Email', ''],
  iconPosition: ['left', 'right', 'top', 'bottom'],
};

Email.propsDataMap = {
  email: ['business', 'primary_location', 'email'],
};
